import { TrashIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { twMerge } from 'tailwind-merge';

export function AddedValuePill({
  value,
  onRemove,
  actionLabel,
  className,
}: {
  value: string;
  onRemove: (value: string) => void;
  actionLabel: string;
  className?: string;
}) {
  return (
    <div
      className={twMerge(
        'flex items-center gap-4 rounded-full border border-neutral-10 bg-neutral-5 px-4 py-1 text-center',
        className,
      )}
    >
      <div className="flex items-center text-center text-sm font-bold">{value}</div>
      <button type="button" onClick={() => onRemove(value)}>
        <TrashIcon className="h-4 w-4" />
        <span className="sr-only">{actionLabel}</span>
      </button>
    </div>
  );
}
